let padNum = (n) => {
  n = '' + n;
  let width = 2 - n.length;
  return width > 0 ? Array(width + 1).join('0') + n : n;
}

let parseMs = ms => {
	if (typeof ms !== 'number') {
		throw new TypeError('Expected a number');
	}

	const roundTowardsZero = ms > 0 ? Math.floor : Math.ceil;

	return {
		hours: roundTowardsZero(ms / 3600000),
		minutes: roundTowardsZero(ms / 60000) % 60,
		seconds: roundTowardsZero(ms / 1000) % 60,
		milliseconds: roundTowardsZero(ms) % 1000
	};
};

let format = (obj = {}, shouldPad = true) => {
  let arr = [];
  arr = Object.keys(obj).slice(0, 3).map(key => {
    return shouldPad ? padNum(obj[key]) : '' + obj[key];
  });
  if (arr[0] == '00') {
    arr.shift(0);
  }
  return arr.join(':')
}

let formatDuration =  (ms) => {
  return format(parseMs(ms));
}

export let formatSecond = (sec) => {
  return formatDuration(sec * 1000);
}

export default formatDuration;



// WEBPACK FOOTER //
// ./src/plugins/formatDuration.js